/* eslint-disable */
/// This file is auto generated - do not edit manually
export const SeeProduct = 'Website.Shared.ProductItem.SeeProduct';
export const DermaLabel = 'Website.Shared.ProductItem.DermaLabel';
export const ReplenishLabel = 'Website.Shared.ProductItem.ReplenishLabel';
export const PossibleAdditionalDeliveryCost = 'Website.Shared.ProductItem.PossibleAdditionalDeliveryCost';
